import { LoggerService } from './logger.service';

/**
 * [!] NOTICE:
 * Only use this logger instance, if you are unable to use dependency injection
 * within your context.
 */
export const logger = new LoggerService();
